import { render, staticRenderFns } from "./PointBankTelecomForm.vue?vue&type=template&id=050fcef9"
import script from "./PointBankTelecomForm.vue?vue&type=script&lang=js"
export * from "./PointBankTelecomForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports